export default "__VITE_ASSET__CYRa06N6__"